<script setup lang="ts">
import type { NoticeCTA } from "@gasparigit/omnia-sdk";
import { buttonVariantsList, type ButtonVariants } from "../ui/button";

const omniaSdk = useOmniaSdk();

const { data } = await useAsyncData("notices", () => {
  try {
    return omniaSdk.v1.notices.firstToSee();
  } catch (error) {
    console.error(error);
  }
});

function closeNotice() {
  try {
    omniaSdk.v1.notices.markAsSeen(data.value.id);
    open.value = false;
  } catch (error) {
    console.error(error);
  }
}

function getVariant(cta: NoticeCTA): ButtonVariants["variant"] {
  if (Object.keys(buttonVariantsList).includes(cta.variant)) return cta.variant as ButtonVariants["variant"];
  return "default";
}

const open = ref(true);
</script>

<template>
  <Dialog v-if="data" v-model:open="open">
    <DialogScrollContent class="max-w-3xl" @pointer-down-outside.prevent unclosable>
      <DialogHeader>
        <DialogTitle>{{ data.title }}</DialogTitle>
        <DialogDescription>
          <p>{{ data.abstract }}</p>
        </DialogDescription>
      </DialogHeader>

      <FrontContentBodyWithFiles class="mb-2" :text="data.body" />

      <template v-if="data.cta?.length">
        <div class="flex flex-col md:flex-row gap-2 items-center justify-center my-3">
          <NuxtLink v-for="cta in data.cta" :key="cta.url" :href="cta.url" target="_blank">
            <Button :variant="getVariant(cta)">
              {{ cta.title }}
            </Button>
          </NuxtLink>
        </div>
      </template>

      <div class="border rounded-sm shadow-sm px-2 py-4 print:shadow-none print:px-2 print:py-4 mt-2" v-if="data.files?.length">
        <template v-for="attachment in data.files">
          <FrontDownloadButton :file="attachment" :title="attachment.title" class="flex items-center mb-5 last:mb-0" v-if="attachment.file">
            <IconsAttach class="w-7 h-7 me-1" />
            <div class="link font-semibold flex gap-2">
              <span>{{ attachment.title }}</span>
              <span class="uppercase whitespace-nowrap">({{ attachment.file.human_readable_size }})</span>
            </div>
          </FrontDownloadButton>
        </template>
      </div>

      <DialogFooter class="mt-4">
        <Button type="submit" variant="ghost" @click="open = false">Mostra più tardi</Button>
        <Button type="submit" @click="closeNotice">Chiudi</Button>
      </DialogFooter>
    </DialogScrollContent>
  </Dialog>
</template>
